import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=521d2a9c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d2a9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521d2a9c')) {
      api.createRecord('521d2a9c', component.options)
    } else {
      api.reload('521d2a9c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=521d2a9c&scoped=true&", function () {
      api.rerender('521d2a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SprintPlanning/Components/Index.vue"
export default component.exports